var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader__register"},[_c('img',{attrs:{"src":require("../../assets/img/loader5.svg"),"alt":""}})])
}]

export { render, staticRenderFns }